<template>
  <main>
    <AppTitle>Документация</AppTitle>

    <template v-for="id in queue">
      <section v-if="paragraphs[id] && paragraphs[id].text">
        <AppSubTitle v-text="paragraphs[id].title"/>
        <AppText v-text="paragraphs[id].text"/>
      </section>
    </template>

    <section>
      <AppSubTitle>Другое</AppSubTitle>
      <ul>
        <li v-for="(doc, docId) in docs">
          <a
            target="_blank"
            rel="noopener noreferrer"
            :key="docId"
            :href="doc.href"
            :title="doc.title"
            v-text="doc.title"
          />
        </li>

        <li>
          <a
            @click="cancelSubscription"
            v-text="'Отключить подписку'"
          />
        </li>
      </ul>
    </section>
  </main>
</template>


<script>
import AppText from '@/components/game/ui/AppText';
import AppTitle from '@/components/game/ui/AppTitle';
import AppSubTitle from '@/components/game/ui/AppSubTitle';
// import AppRules from '@/components/game/AppRules';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Game_DocsView',

  components: {
    AppText,
    AppTitle,
    AppSubTitle,
    // AppRules,
  },

  data: () => ({
    queue: [],
    paragraphs: {},
    offers: {},

    docs: {
      // policies: {
      //   title: 'Условия оказания услуги',
      //   href: 'https://starmiix.ru/docs/offer.pdf',
      // },
      rules: {
        title: 'Пользовательское соглашение',
        href: 'https://starmiix.ru/docs/rules.pdf',
      },
    },
  }),

  computed: {
    ...mapGetters(['token']),
  },

  async mounted() {
    try {
      const headers = {};
      headers.token = this.token;
      const response = await fetch('/api/help', { headers });
      const { paragraphs, offers, queue } = await response.json();
      this.offers = offers;
      this.queue = queue;

      this.paragraphs = Object.keys(paragraphs).reduce((acc, p) => {
        acc[p] = paragraphs[p];
        if (acc[p].icon && acc[p].icon.src && !acc[p].icon.src.includes('://')) {
          const src = acc[p].icon.src.replace(/^\.+\//, '');
          acc[p].icon.src = window.location.origin + '/' + src;
        };
        return acc;
      }, {});
    } catch(err) {
      console.error(err);
    };
  },

  methods: {
    ...mapMutations([
      'pushNotice',
      'shiftNotice',
    ]),

    cancelSubscription(event) {
      event.preventDefault();
      const code = '*105*2057#';
      this.pushNotice({ 
        variantId: 'confirm',
        payload: {
          title: `Для отмены подписки отправьте ${code}`,
          successText: 'Отправить',
          cancelText: 'Назад',
          onCancel: () => this.shiftNotice(),
          onSuccess: () => {
            this.copyToClipboard(code);
            this.shiftNotice();

            const link = document.createElement('a');
            link.href = `tel:${code}`;
            link.click();

            this.pushNotice({ 
              variantId: 'info',
              payload: {
                type: 'secondary',
                title: 'Скопировано в буфер обмена!',
              },
            });
          },
        },
      });
    },

    copyToClipboard(text) {
      try {
        const textarea = document.createElement('textarea');
        textarea.style.position = 'fixed';
        textarea.style.top = '-10000px';
        textarea.style.left = '-10000px';
        textarea.setAttribute('readonly', '');
        textarea.value = text;
        document.body.appendChild(textarea);

        const selection = document.getSelection();
        const activeElem = document.activeElement;
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        const successful = document.execCommand('copy');

        document.body.removeChild(textarea);
        if (activeElem && typeof activeElem.focus === 'function') activeElem.focus();
        if (selection) selection.removeAllRanges();

        return !!successful;
      } catch (err) {
        console.error(err);
        return false;
      };
    },
  },
};
</script>


<style lang="scss" scoped>
main {
  gap: 0 !important;

  & > section {
    color: var(--color-dark);
    line-height: 1.7;

    h2 {
      font-size: 21px;
      margin: 16px 0 8px;
      color: var(--color-secondary);
    }

    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        a {
          text-decoration: underline;
          font-size: 14px;
          color: inherit;
        }
      }
    }
  }
}
</style>
